import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import 'react-telephone-input/css/default.css';
import CustomFields from '../../../../components/customFields/CustomFields';
import SectionHeader from '../../../../components/sectionHeader';
import PERMITMODULE from '../../../../icons/PERMITMODULE.png';
import DEFAULTFIELDS from './DEFAULTFIELDS';
import styles from './form.module.scss';
import Button from '../../../../components/button';
import { GetFileName, S3Uploads } from '../../../services';
import HeaderBack from '../../../../components/headerBack';
import { changeCurrentPage } from '../../../../general_redux/actions';
import {
  fetchspecificAdpLogs,
  initiateApplication,
  getAdpDefaultFields, clearState
} from '../../redux/action';
import Loading from '../../../../components/loading';
import FormattedMessageWithClass from '../../../../components/formattedMessageWithClass';
import { carryForwardAttachments, filterCustomFieldAnswers, getAttachmentIds } from '../../components/PermitData';
import { PERMIT_ALREADY_RENEWED } from '../../constant';

const RenewalForm = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();
  const { id, installationId, airportCode } = params;
  const { myApplication } = props;
  const logId = id;
  const renewalApplication = useSelector(states => states?.permitManagement?.specificLog);
  const adpSchema = useSelector(states => states?.permitManagement?.adpSchema);
  const renewalFields = useSelector(state => state.permitManagement?.adpRenewalFields);
  const customFields = useSelector(state => state.permitManagement?.AdpCSchema);
  const oldCustomFields = useSelector(data => data?.permitManagement?.adpCSchema);
  const [state, setState] = useState({
    answers: {
      application_type: 'Renewal'
    },
    formErrors: false
  });
  const profile = useSelector(states => states.auth.profile);
  const [errors, setErrors] = useState({});
  const [isAlreadySubmited, setIsAlreadySubmited] = useState(false);
  const [renewalErrors, setRenewalErrors] = useState({});
  const [isLoader, setIsLoader] = useState(false);
  const loader = useSelector(states => states?.permitManagement?.adpInitiationStatus);
  const loaderForRenewal = useSelector(states => states?.permitManagement?.loader);
  const errorResponse = useSelector(states => states.permitManagement?.errorResponse);
  const newApplicaitonFields = DEFAULTFIELDS.map((ele) => {
    if (ele.id === 'application_type') {
      return {
        ...ele,
        values: [
          {
            key: 'Renewal',
            value: 'Renewal'
          }
        ]
      };
    }
    return { ...ele };
  });
  const [initFormFields, setInitFormFields] = useState(newApplicaitonFields);

  useEffect(() => {
    if (logId) {
      dispatch(fetchspecificAdpLogs(logId));
    }
  }, [dispatch, logId]);

  useEffect(() => {
    if (loader.error === true && errorResponse === PERMIT_ALREADY_RENEWED) {
      setIsAlreadySubmited(true);
      setIsLoader(false);
    }
  }, [errorResponse, loader]);

  useEffect(() => {
    dispatch(changeCurrentPage(profile?.permit_management?.driver_permit || 'ADP'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(getAdpDefaultFields());
  }, [dispatch]);

  useEffect(() => {
    if (renewalFields?.length > 0) {
      let renewalReq = {};
      renewalFields.forEach((ele) => {
        // checking required fields
        if (ele.required) {
          renewalReq = { ...renewalReq, [ele.id]: true };
        }
      });
      setRenewalErrors(renewalReq);
    }
  }, [renewalFields]);

   useEffect(() => () => {
      // cleanup runs on unmount
      dispatch(clearState());
    }, [dispatch]);

  useEffect(() => {
    if (adpSchema) {
      let designation_title = adpSchema?.default_fields?.default_field?.find(ele => ele?.id === 'designation')?.title || 'Designation';
      let updatedFormFields = initFormFields.map((ele) => {
        if (ele.id === 'designation' && designation_title) {
          return { ...ele, title: designation_title };
        }
        return { ...ele };
      });
      setInitFormFields(updatedFormFields);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adpSchema]);

  // for renewal process
  useEffect(() => {
    if (logId) {
      setState({
        answers: {
          application_type: renewalApplication?.application_type ? 'Renewal' : '',
          designation: renewalApplication?.designation ? renewalApplication?.designation : '',
          email: renewalApplication?.email ? renewalApplication?.email : '',
          phone: renewalApplication?.phone ? renewalApplication?.phone : '',
          first_name: renewalApplication?.first_name ? renewalApplication.first_name : '',
          last_name: renewalApplication?.last_name ? renewalApplication.last_name : '',
          use_prev_badge: false,
          offline_training: false
        },
        formErrors: false
      });
      setErrors({
        application_type: false,
        designation: false,
        email: false,
        phone: false,
        first_name: false,
        last_name: false
      });
    }
  }, [renewalApplication, setState, setErrors, logId]);

  const handleAnswerChanged = (answer, fieldId) => {
    setState({ ...state, answers: { ...state.answers, [fieldId]: answer } });
  };

  const handleRenewalAnswerChanged = (answer, fieldId) => {
    setState({ ...state, answers: { ...state.answers, renewal_response: { ...state.answers.renewal_response, [fieldId]: answer } } });
  };

  const getFileNames = async (count) => {
    const response = await GetFileName.getUploadFileName(count);
    return response;
  };

  const doS3Upload = async (files, fileIds, entity) => {
    const response = await S3Uploads.uploadFiles(
      files,
      fileIds.filename,
      entity,
      installationId,
      airportCode
    );
    return response;
  };

  // ----------- Attachment Upload function start -----------
  const handleUploadAttachments = async (attachments, entity) => {
    const attachmentIds = [];
    const newAttachments = [];
    const oldAttachments = [];
    attachments.forEach((e) => {
      if (!e.id) {
        newAttachments.push(e);
      } else if (e.id && e.name) {
        oldAttachments.push(e.name);
      }
    });
    let fileIds = '';
    if (newAttachments.length > 0) {
      fileIds = await getFileNames(newAttachments?.length);
    }
    if (fileIds) {
      await doS3Upload(
        newAttachments,
        fileIds,
        entity || 'driver_permit'
      ).then(() => {
        fileIds.filename.forEach((i) => {
          attachmentIds.push(i.toString());
        });
      });
    }
    if (oldAttachments.length > 0) {
      attachmentIds.push(...oldAttachments);
    }
    return attachmentIds;
  };

  const uploadRenewalAttachments = async () => {
    const attachmentFields = renewalFields.filter(
        schemaField => schemaField?.type === 'attachments'
    );
    const uploadingAttachments = attachmentFields.map(async (schemaField) => {
      const attachmentField = schemaField?.id;
      if (schemaField?.type === 'attachments' && state.answers?.renewal_response?.[attachmentField]?.length > 0) {
        state.answers.renewal_response[attachmentField] = await handleUploadAttachments(state.answers.renewal_response[attachmentField],
           'driver_permit');
      }
    });
    await Promise.all(uploadingAttachments);
  };

  const handelSubmit = async () => {
    setIsAlreadySubmited(false);
    const noErrors = Object.keys(errors).every(k => errors[k] === false);
    const noRenwalErrors =renewalFields? Object.values(renewalErrors).every(value => value === false): true;
    if (noErrors && noRenwalErrors) {
      setIsLoader(true);
      const data = {
        ...state.answers,
        prev_permit: renewalApplication?.id ? renewalApplication?.id : null,
        prev_badge_no: state?.answers?.use_prev_badge
        ? renewalApplication?.badge_no
        : null
      };
      data.phone = data.phone[0] + data.phone.slice(1).replace(/[^\d]/g, '');

      if (renewalFields) {
        await uploadRenewalAttachments();
      }

      if (renewalApplication.initiated_to) {
        data.initiated_to= renewalApplication?.initiated_to?.id;
      }
    // ----------- Forward Attachments to Renewal Application -----------
      const attachmentData = {
        req_attachments: renewalApplication?.req_attachments || {},
        req_attachments_details: renewalApplication?.req_attachments_details || {},
        photo: renewalApplication?.photo
      };
      const newRequiredAttachments = adpSchema?.default_fields?.required_attachements || [];

      const filteredAnswers = filterCustomFieldAnswers(oldCustomFields, customFields, renewalApplication?.response);
      const filteredResponse = getAttachmentIds(filteredAnswers);
      const adminResponse = state.answers?.admin_response ? getAttachmentIds(state.answers.admin_response) : {};

      const updatedData = carryForwardAttachments(attachmentData, newRequiredAttachments, renewalApplication);
      data.req_attachments = updatedData.req_attachments;
      data.req_attachments_details = updatedData.req_attachments_details;
      data.attachments = updatedData.attachments;
      data.photo = updatedData.photo;
      data.response = filteredResponse;
      data.admin_response = adminResponse;
    // ----------- Forward Attachments to Renewal Application -----------

      dispatch(initiateApplication(data));
      setState({ ...state, formErrors: false });
    } else {
      setState({ ...state, formErrors: true });
    }
  };

  const getRequired = (data) => {
    let requiredKeys = {};
    data.forEach((ele) => {
      if (ele.required) {
        requiredKeys = { ...requiredKeys, [ele.id]: true };
      }
    });
    return requiredKeys;
  };

  const getRenewalRequired = () => {
    let requiredKeys = {};
    if (renewalFields?.length !== 0) {
      renewalFields.forEach((ele) => {
        // checking required fields
        if (ele.required) {
            requiredKeys = { ...requiredKeys, [ele.id]: true };
        }
      });
    }
    return requiredKeys;
  };

  const handleFieldErrorChanged = (fieldID, value) => {
    setErrors({ ...errors, [fieldID]: value });
  };

  const handleRenewalFieldErrorChanged = (fieldId, value) => {
    setRenewalErrors(prevErr => ({ ...prevErr, [fieldId]: value }));
  };

  useEffect(() => {
    setErrors(getRequired(DEFAULTFIELDS));
  }, []);

  useEffect(() => {
    if (loader?.success) {
      setIsLoader(false);
      let usePath = '';
      if (myApplication) {
        usePath = '/adp/myapplications';
      } else {
        usePath = '/adp/logs';
      }
      history.push(usePath);
    }
  }, [loader, history, myApplication]);

  return (
    <>
      <Loading loadingStatus={loader.loading || (loaderForRenewal && logId) || isLoader} />
      <SectionHeader
        {...props}
        centered
        icon={PERMITMODULE}
        translationID=" "
        defaultTitle={`Renewal ${profile?.permit_management?.driver_permit || 'ADP'}`}
      />
      <HeaderBack
        translationID="workorder.settings.back"
        translationDefault="Back"
      />
      <div className={styles.container}>
        <div className={styles.headder}>
          <FormattedMessageWithClass
            id=" "
            defaultMessage="Renewal Application"
            tagName="h4" />
        </div>
        <div style={{ padding: '20px' }}>
          <CustomFields
            handleAnswerChanged={(a, b) => handleAnswerChanged(a, b)}
            handleFieldErrorChanged={(a, b) => handleFieldErrorChanged(a, b)}
            showFormErrors={state.formErrors}
            requiredMap={getRequired(initFormFields)}
            fields={initFormFields}
            applicationType="Renewal"
            answers={state.answers}
            errors={errors}
            renewal
            adprenewal
            forQuestionMarkHelp
          />
          {renewalFields?.length > 0
          && <CustomFields
                handleAnswerChanged={(a, b) => (handleRenewalAnswerChanged(a, b))}
                handleFieldErrorChanged={(a, b) => handleRenewalFieldErrorChanged(a, b)}
                showFormErrors={state.formErrors}
                requiredMap={getRenewalRequired(renewalFields, true, renewalErrors, state?.answers?.renewal_response)}
                fields={renewalFields}
                applicationType="Renewal"
                answers={state.answers?.renewal_response || {}}
                adp
                forQuestionMarkHelp
              />
          }
          <label htmlFor="adp_number">
            <input
              type="checkbox"
              id="adp_number"
              style={{ margin: '0 5px' }}
              onChange={(e) => { setState({ ...state, answers: { ...state.answers, use_prev_badge: e.target.checked } }); }}
              value={state.answers.use_prev_badge}
            />
              <FormattedMessageWithClass
                id=" "
                defaultMessage="Use Same Permit Number" />
          </label>
          {!renewalApplication?.settings?.initiateWithPortalUsers && (
            <label htmlFor="offline_training" style={{ margin: '0 15px' }}>
              <input
              id="offline_training"
              type="checkbox"
              style={{ margin: '0 5px' }}
              onChange={(e) => { setState({ ...state, answers: { ...state.answers, offline_training: e.target.checked } }); }}
              value={state?.answers?.offline_training}
              />
              <FormattedMessageWithClass
                id=" "
                defaultMessage="User Has Taken Offline Training" />
            </label>
          )}
        </div>
        <div className={styles.submitButton} style={{ justifyContent: `${state.formErrors
          || isAlreadySubmited === true ? 'space-between': 'flex-end'}` }}>
          {state.formErrors && isAlreadySubmited === false && (
            <FormattedMessageWithClass
              id=" "
              defaultMessage="* Please fill all the required fields"
              className={styles.errorMessage}
              tagName="p" />
          )}
          {isAlreadySubmited === true && (
            <FormattedMessageWithClass
              id=" "
              defaultMessage="A Renewal Application is Already In Progress. Please Cancel This."
              className={styles.errorMessage}
              tagName="p" />
          )}
          <Button
            action="tertiary"
            onClick={() => { history.push(`/adp/detail/${id}`); setIsAlreadySubmited(false); }}
            translationID="inspections.new.cancelBtn"
            defaultText="Cancel"
          />
          <Button
            action="secondary"
            onClick={() => (handelSubmit())}
            translationID="adp.submit"
            defaultText="Submit"
          />
        </div>
      </div>
    </>
  );
};
export default RenewalForm;
